export const unMaskPhone = (phone: string | undefined | null) => {
  if (!phone) {
    return '';
  }
  return phone.replace(/\D/g, '').substring(0, 10);
};

// Returns true if any of the fields are dirty
export const hasModifiedFields = (fields: Record<string, boolean>) => {
  return !!Object.keys(fields).filter(key => fields[key]).length;
};
